import React from 'react'


const Testimonials = () => {
  return (
    <section id="testimonials">
      <h2 className="m-heading is-center py-1">Testimonials</h2>
      <div className="items">
        <div className="item item-1">
          <p><span className="quote">"</span>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
            Placeat possimus cupiditate, impedit ad officia quas ex 
            explicabo ab magni qui!<span className="quote">"</span></p>
          <p> - Katlyn </p>
        </div>
        <div className="item item-2">
          <p><span className="quote">"</span>Lorem ipsum dolor sit amet, consectetur adipisicing elit. 
            Accusantium, qui!<span className="quote">"</span></p>
          <p> - David</p>
        </div>
        <div className="item item-3">
          <p className=""><span className="quote">"</span>Lorem ipsum dolor sit amet consectetur adipisicing elit. 
            Autem eum eos laborum possimus nihil.<span className="quote">"</span></p>
          <p > - Alex</p>
        </div>
      </div>
      
    </section>
  )
}

export default Testimonials
